<template>
  <div>
    <div
      class="row et_row_complete text-center p-0 py-4 cpl-event col-12 col-md-6 m-auto"
    >
      <!-- charity -->
      <div class="col-6">
        <div
          :title="store.state.selected_charity.BeneficiaryName"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="store.state.selected_charity.BeneficiaryImagePath"
            class="card-img-top img-fluid"
            alt=""
          >
        </div>
        <p>{{ store.state.selected_charity.BeneficiaryName }}</p>
      </div>
      <!-- event -->
      <div class="col-6">
        <div
          :title="store.state.selected_event.EventName"
          class="card border-0 hv-100 bg-transparent"
        >
          <img
            :src="useImagePlugin().getImageWithResolution(store.state.selected_event.EventImagePath,1000)"
            class="card-img-top img-fluid"
          />
        </div>
        <p>{{ store.state.selected_event.EventName }}</p>
      </div>
    </div>
    <div class="col m-auto">
      <div class="gf-connect-fb">
        <template v-if="store.state.userLogon">          
          <div class="eb-pt-row-login">
            <div class="row justify-content-md-center mx-1 mt-3">
              <div class="col bgr-main ">
                <slot name="terms"></slot>
                <Logged />
              </div>                            
            </div>
          </div>          
        </template>
        <template v-else>
          <Loader :show="store.state.creatingPage" />
          <GfLoginModule 
            :custom-container-class="'col'"
            :provider-details="providerDetails"
            :captcha-public-key="captchaPublicKey"
            :facebook="facebookAuth"
            @logged-in="$_createFundraisingPageMixin_onLoggedIn"
            :disable-redirect="true"
            :is-page-create="true"
            :register-url="registerUrl"
            template="tab"
          >
            <template #terms>
              <slot name="terms"></slot>
            </template>
          </GfLoginModule>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Logged from "../login/Logged.vue"
import CreateFundraisingPageMixin from "../inc/CreateFundraisingPageMixin.vue"
import useImagePlugin from "../../composables/useImagePlugin"
import { GfLoginModule } from '@gf/gf-login-vue-3' 
import Loader from '../inc/Loader.vue'

export default {
  components: {
    Logged,
    GfLoginModule,
    Loader,
  },
  mixins: [CreateFundraisingPageMixin],

  data() {
    return {
      useImagePlugin,
    }
  },

  async mounted() {
    (this.pageType = "S"), (this.teamId = 0);
    this.charityId = this.store.state.selected_charity.beneficiaryId;
    this.eventCampaignId = this.store.state.selected_event.EventCampaignId;
    await Promise.all([this.loadVueAnalytics(), this.$_createFundraisingPageMixin_loadDisclaimer()]);
  },
};
</script>
<style scoped>
.card-img-top.img-fluid {
  width: 100%;
  height: 8vw;
  object-fit: contain;
}
</style>
<style>
@import "../../assets/css/aws-amplify.css";
</style>